module.exports = __webpack_public_path__ + "img/logo.ab0ddc28.svg";